import { render } from "./company-selector.vue?vue&type=template&id=996ea4bc&ts=true"
import script from "./company-selector.vue?vue&type=script&lang=ts"
export * from "./company-selector.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__